export function getApplicationTabNameByType(applicationType) {
    switch (applicationType) {
        case 'after-hours-permit':
            applicationType = 'afterHoursPermit'
            break
        case 'determination':
        case 'tracking':
            break
        case 'dot-permit':
            applicationType = 'dotPermits'
            break
        case 'misc-service':
            applicationType = 'miscServices'
            break
        case 'occupancy-certificate':
            applicationType = 'certificateOfOccupancy'
            break
        default:
            applicationType = applicationType + 's'
    }
    return applicationType
}

export function checkPermissions(requiredPermissions, userPermissions) {
    if (!requiredPermissions) {
        return true;
    }

    let requiredParts = requiredPermissions.split('.');
    // Checking for the route permissions
    let currentRoutePermissions = userPermissions[requiredParts[0]] ?? false;

    if (!currentRoutePermissions) {
        // No valid route permissions;
        return false;
    }

    if (requiredParts[1] === 'index') {
        return currentRoutePermissions.enabled ?? false;
    } else  {
        return currentRoutePermissions[requiredParts[1]] === true;
    }

}
